import { DateInput } from "@msuite/ui/date-input";
import { useTranslation } from "@msuite/ui/localization";
import type { AddAttendanceForUserFormSchema } from "@msuite/utils/schemas";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import { UserPicker } from "@/components/pickers/user-picker";
import { AttendanceForm } from "@/forms/attendance-form";

/** Props Interface */
interface AddAttendanceFormProps {
	/** Whether the person is picked here, or fixed by the sheet the form was opened from. */
	isUserPickable: boolean;
}

export function AddAttendanceForm({ isUserPickable }: AddAttendanceFormProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<AddAttendanceForUserFormSchema>();

	/** Render */
	return (
		<Fragment>
			{isUserPickable && (
				<UserPicker
					control={methods.control}
					name="userId"
				/>
			)}
			<DateInput
				label={t("dates.date")}
				control={methods.control}
				name="date"
				maxDate={new Date()}
				isRequired
			/>
			<AttendanceForm />
		</Fragment>
	);
}
